import { zodResolver } from '@hookform/resolvers/zod'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'

import { CenterLecCommentInput } from '../../../../../../../lib/types/models/center-lec-comment/center-lec-input'
import { BaseFormProps } from '../../../../../../../lib/types/utils'
import { getSubmitAction } from '../../../../../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../../../../../utils/constants/form.constants'
import ControlledSwitch from '../../../../../../elements/controlled-switch'
import DateChip from '../../../../../../elements/date-chip'
import { Form, FormControl, FormField, FormItem } from '../../../../../../elements/forms/form'
import ControlledInput from '../../../../../../elements/inputs/controlled-input'
import ValidationButtons from '../../../../../../elements/validation-buttons'
import { centerLecCommentFormSchema } from './utils'

const CenterLecCommentForm = ({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<CenterLecCommentInput, true>) => {
  const form = useForm<CenterLecCommentInput>({
    resolver: zodResolver(centerLecCommentFormSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
        className="px-4 flex flex-col gap-3"
      >
        <div className="pt-7">
          <DateChip date={defaultValues?.updatedAt ?? new Date()} label={'Date'} />
        </div>
        <FormField
          control={form.control}
          name="comment"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledInput {...field} type="textarea" label="Votre commentaire..." />
              </FormControl>
            </FormItem>
          )}
        />
        <div>
          <Typography variant="tag" color={tailwindColors.grey.DEFAULT}>
            Visibilité :
          </Typography>
          <div className="h-2" />
        </div>
        <FormField
          control={form.control}
          name="sharedToOl"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledSwitch {...field} label="Partagé avec OL" variant="tag" />
              </FormControl>
            </FormItem>
          )}
        />

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default CenterLecCommentForm
